import { render, staticRenderFns } from "./TranslationForm.vue?vue&type=template&id=7078eb66&"
import script from "./TranslationForm.vue?vue&type=script&lang=js&"
export * from "./TranslationForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslationForm.vue?vue&type=style&index=0&id=7078eb66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports